<div data-id="routine-dynamic-container">
    <div class="row" style="margin-bottom: 6px">
        <div class="col-12">
            <h4 class="text-white">
                <%= question %>
            </h4>
        </div>
    </div>
    <div class="row"
         style="margin-bottom: 0"
         data-id="routine-dynamic-selection">
        <div class="col-12">
            <div class="routine-check shadow-l rounded-2 mb-3 d-flex"
                 data-type="routine-selection">
                <div class="align-self-center" style="min-width: 40px">
                    <% if ( icon ) {  %>
                        <img src="assets/icons/routines/<%= icon %>" style="max-width: 18px; margin-left: 11px; margin-bottom: 4px;" />
                    <% }  %>
                </div>
                <div class="align-self-center routine-name" data-id="dynamic-value">
                    <%= value %>
                </div>
                <div class="ms-auto ps-3 align-self-center text-center" style="min-width: 50px!important;">
                    <i class="fa fa-chevron-right" style="padding-top: 9px"></i>
                </div>
            </div>
        </div>
    </div>
</div>
